<template>
    <div class="ui-headline">
        <slot>{{ text }}</slot>
    </div>
</template>

<script>
    export default {
        name: 'ui-headline',
        props: ['text'],
    };
</script>

<style>
    .ui-headline {
        font-weight:600;
        font-size: 1.28em;
        line-height:1.5em;
        margin: 0px 0px 12px 0px;
        letter-spacing: 0.02em;
        text-rendering: optimizeLegibility;
    }
</style>



// WEBPACK FOOTER //
// UiHeadline.vue?52dfc788